import { Component } from '@angular/core'
import { RouterModule } from '@angular/router'
import { TranslocoDirective } from '@jsverse/transloco' // Import TranslocoDirective
import { scrollToAnchor } from '../../utils/scroll-utils'

@Component({
    selector: 'endevelo-footer',
    imports: [RouterModule, TranslocoDirective], // Add TranslocoDirective to imports
    templateUrl: './footer.component.html'
})
export class FooterComponent {
    scrollToAnchor = scrollToAnchor
}
